import {AnimatedBarChartLazy} from 'app/components/animatedBarChart/lazy';
import {ApiBoxesLazy} from 'app/components/apiBoxes/lazy';
import {ApiLinkLazy} from 'app/components/apiLink/lazy';
import {ApiPoweredContainerLazy} from 'app/components/apiPoweredContainer/lazy';
import {APITableLazy} from 'app/components/apiTable/lazy';
import {AudioContainerLazy} from 'app/components/audioContainer/lazy';
import {BarcodeLazy} from 'app/components/barcode/lazy';
import {BeReadyLikesLazy} from 'app/components/beReadyLike/lazy';
import {BoxContainerAuthorLazy} from 'app/components/boxContainer/author/lazy';
import {BoxContainerConfigLazy} from 'app/components/boxContainer/config/lazy';
import {BoxContainerLazy, BoxContainerPBLazy} from 'app/components/boxContainer/lazy';
import {BoxFilterContainerLazy} from 'app/components/boxFilterContainer/lazy';
import {BranchSearchListLazy, BranchSearchMapAndListLazy} from 'app/components/branchSearchOld/lazy';
import {WebinarDetailsLazy} from 'app/components/bullsAndBears/webinarDetails/lazy';
import {SuperheroCarouselLazy} from 'app/components/carouselSSR/superhero/lazy';
import {TextWithImageCarouselLazy} from 'app/components/carouselSSR/twi/lazy';
import {DynamicChartLazy, StaticPieChartLazy} from 'app/components/chart/lazy';
import {ComboboxLazy} from 'app/components/combobox/lazy';
import {CommentsLazy} from 'app/components/comments/lazy';
import {TimebankLazy} from 'app/components/communities/timebank/lazy';
import {CompactOffersListLazy} from 'app/components/compactOffersList/lazy';
import {CompactTabNavigationLazy} from 'app/components/compactTabNavigation/lazy';
import {CookieWriterLazy} from 'app/components/cookieWriter/lazy';
import {CountrySelectionLazy} from 'app/components/countrySelection/lazy';
import {CreReferencesMapLazy} from 'app/components/creReferencesMap/lazy';
import {DisclaimerActionLazy, DisclaimerOverlaysLazy} from 'app/components/disclaimer/lazy';
import {EmployeeListLazy} from 'app/components/employeeList/lazy';
import {OffersListLazy} from 'app/components/etbOffersList/lazy';
import {EventsFilterLazy} from 'app/components/eventFilter/lazy';
import {EventTeaserLazy} from 'app/components/eventTeaser/lazy';
import {FileInfoLazy} from 'app/components/fileList/fileInfo/lazy';
import {FooterAuthorLazy, FooterLazy} from 'app/components/footer/lazy';
// eslint-disable-next-line import-x/no-cycle
import {FormLazy} from 'app/components/form/lazy';
import {FundStructureChartProps} from 'app/components/fundFactsheet/containers/fundChart/interfaces';
import {
    FundBoxAppLazy,
    FundChartAppLazy,
    FundDocumentAppLazy,
    FundHeaderAppLazy,
    FundStructureChartAppLazy,
    FundTableAppLazy,
    FundTextAppLazy,
} from 'app/components/fundFactsheet/lazy';
import {FundModuleLazy} from 'app/components/fundModule/lazy';
import {FundScenariosLazy} from 'app/components/fundScenarios/lazy';
import {FundSearchBoxLazy} from 'app/components/fundSearchBox/lazy';
import {CurrencyConverterLazy} from 'app/components/fxCurrencyConverter/lazy';
import {FxRatesChartLazy} from 'app/components/fxRatesChart/lazy';
import {FxRatesTableLazy} from 'app/components/fxRatesTable/lazy';
import {GlossaryLazy} from 'app/components/glossary/lazy';
import {GoBackLazy} from 'app/components/goBack/lazy';
import {GroupMapLazy} from 'app/components/groupMap/lazy';
import {GroupTimelinesLazy} from 'app/components/groupTimelines/lazy';
import {HeaderLazy} from 'app/components/header/lazy';
import {HeaderButtonLazy} from 'app/components/headerButton/lazy';
import {HelpCenterEsLazy} from 'app/components/helpCenterListEs/lazy';
import {HeroSearchLazy} from 'app/components/heroSearch/lazy';
import {InPageNavigationInitLazy} from 'app/components/inPageNavigation/lazy';
import {InstituteSelectionLazy} from 'app/components/instituteSelection/lazy';
import {JobDetailLazy} from 'app/components/jobDetail/lazy';
import {MapSmallLazy} from 'app/components/mapSmall/lazy';
import {MobileHeaderLazy} from 'app/components/mobileHeader/lazy';
import {NewsArchiveLazy} from 'app/components/newsFilterContainer/newsArchive/lazy';
import {NewsConfigLazy} from 'app/components/newsFilterContainer/newsConfig/lazy';
import {NewsHeadlineLazy} from 'app/components/newsFilterContainer/newsHeadline/lazy';
import {NewsTimelineLazy} from 'app/components/newsFilterContainer/newsTimeline/lazy';
import {PdfLibraryLazy} from 'app/components/pdfLibrary/lazy';
import {PlaceDetailsLazy} from 'app/components/placeDetails/lazy';
import {PollLazy} from 'app/components/poll/lazy';
import {ProductHighlightLazy} from 'app/components/productHighlight/lazy';
import {ProductPricingBoxContainerLazy} from 'app/components/productPricingBoxContainer/lazy';
import {FinalTermsLazy} from 'app/components/samDocumentSearch/finalTerms/lazy';
import {PriipsLazy} from 'app/components/samDocumentSearch/priips/lazy';
import {SearchLazy} from 'app/components/search/lazy';
import {SectionWithEffectsLazy} from 'app/components/sectionWithEffects/lazy';
import {SectionWithRestrictedAccessLazy} from 'app/components/sectionWithRestrictedAccess/lazy';
import {initSmartBanner} from 'app/components/smartBanner';
import {SocialMediaFeedLazy} from 'app/components/socialMediaFeed/lazy';
import {StickyColumnLazy} from 'app/components/stickyColumn/lazy';
import {SuperformLazy} from 'app/components/superform/lazy';
import {SuperheroSSRLazy} from 'app/components/superheroSSR/lazy';
import {FmTableLazy} from 'app/components/table/fm/lazy';
import {TableLazy} from 'app/components/table/lazy';
import {PbTableLazy} from 'app/components/table/pb/lazy';
import {WsdTableLazy} from 'app/components/table/wsd/lazy';
import {TableArchiveLazy} from 'app/components/tableArchive/lazy';
import {TabNavigationLazy} from 'app/components/tabNavigation/lazy';
import {TextSizeLazy} from 'app/components/textSize/lazy';
import {ToggleLazy} from 'app/components/toggle/lazy';
import {UnrestrictedHtmlLazy} from 'app/components/unrestrictedHtml/lazy';
import {UserProfileLazy} from 'app/components/userProfile/lazy';
import {GemModuleItems} from 'app/interface';
import {StickyLinksLazy} from 'app/modules/stickyLinks/lazy';
import {getShouldSkipLazyLoadFn} from 'app/utils/initialize/getShouldSkipLazyLoadFn';
import {SuperheroCarouselConfig} from 'interfaces/common/components/carousel/superheroCarouselConfig';
import {TextWithImageCarouselConfig} from 'interfaces/common/components/carousel/textWithImageCarouselConfig';
import {ChartConfig} from 'interfaces/common/components/general/chart/chartConfig';
import {BranchSearchConfig} from 'interfaces/locations/components/branchsearch/branchSearchConfig';
import {AndroidAppBannerConfig} from 'interfaces/shared/components/pages/smartappbanner/androidAppBannerConfig';
import {ContactPageMapLazy} from 'modules/contactPageMap/lazy';

export const componentItems: GemModuleItems = {
    'sticky-links': {
        reactLazyComponent: () => StickyLinksLazy,
        hasConfig: false,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'pdf-library': {
        reactLazyComponent: () => PdfLibraryLazy,
    },
    'event-filter-box': {
        reactLazyComponent: () => EventsFilterLazy,
    },
    'event-teaser': {
        reactLazyComponent: () => EventTeaserLazy,
    },
    'webinar-details': {
        reactLazyComponent: () => WebinarDetailsLazy,
    },
    'external-widget-loader': {
        import: () => import(/* webpackChunkName: "externalWidgetLoader" */ 'app/components/externalWidgetLoader'),
        hasConfig: false,
    },
    'job-details': {
        reactLazyComponent: () => JobDetailLazy,
    },
    link: {
        import: () => import(/* webpackChunkName: "link" */ 'app/components/link'),
        hasConfig: false,
    },
    'link-item': {
        import: () => import(/* webpackChunkName: "linkItem" */ 'app/modules/linkItem'),
    },
    'input-field': {
        import: () => import(/* webpackChunkName: "formInput" */ 'app/components/formInput'),
    },
    'opt-in': {
        import: () => import(/* webpackChunkName: "optIn" */ 'app/components/optIn'),
        hasConfig: false,
    },
    'slsp-resource-signing': {
        import: () => import(/* webpackChunkName: "slspResourceSigning" */ 'app/components/slspResourceSigning'),
    },
    'fed-login-cookie': {
        reactLazyComponent: () => CookieWriterLazy,
    },
    'fund-module': {
        reactLazyComponent: () => FundModuleLazy,
    },
    'fund-header': {
        reactLazyComponent: () => FundHeaderAppLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'fund-text': {
        reactLazyComponent: () => FundTextAppLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'fund-table': {
        reactLazyComponent: () => FundTableAppLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'fund-document': {
        reactLazyComponent: () => FundDocumentAppLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'fund-chart': {
        reactLazyComponent: ({config}) => {
            const fundStructureChartConfig = config as FundStructureChartProps;
            if (fundStructureChartConfig.type === 'STRUCTURE_CHART') {
                return FundStructureChartAppLazy;
            }

            return FundChartAppLazy;
        },
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'fund-search-box': {
        reactLazyComponent: () => FundSearchBoxLazy,
    },
    'fund-box-container': {
        reactLazyComponent: () => FundBoxAppLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'form-reference': {
        import: () => import(/* webpackChunkName: "formReference" */ 'app/components/formReference'),
    },
    form: {
        reactLazyComponent: () => FormLazy,
        removePortalContent: false,
    },
    'form-confirmation': {
        import: () => import(/* webpackChunkName: "formConfirmation" */ 'app/components/formConfirmation'),
        hasConfig: false,
    },
    'fx-currency-converter': {
        reactLazyComponent: () => CurrencyConverterLazy,
    },
    disclaimer: {
        reactLazyComponent: () => DisclaimerOverlaysLazy,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'disclaimer-action': {
        reactLazyComponent: () => DisclaimerActionLazy,
    },
    'section-with-headline': {
        import: () => import(/* webpackChunkName: "sectionWithHeadline" */ 'app/components/sectionWithHeadline'),
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('sectionWithHeadline'),
    },
    'sam-document-search-final-terms': {
        reactLazyComponent: () => FinalTermsLazy,
    },
    'sam-document-search-priips': {
        reactLazyComponent: () => PriipsLazy,
    },
    'text-size': {
        reactLazyComponent: () => TextSizeLazy,
        hasConfig: false,
    },
    table: {
        reactLazyComponent: ({gemSettings}) => {
            switch (gemSettings.theme) {
                case 'wsd':
                    return WsdTableLazy;
                case 'flottenmanagement':
                    return FmTableLazy;
                case 'privatebanking':
                    return PbTableLazy;
                default:
                    return TableLazy;
            }
        },
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('table'),
    },
    'api-table': {
        reactLazyComponent: () => APITableLazy,
    },
    'place-details': {
        reactLazyComponent: () => PlaceDetailsLazy,
    },
    'fx-rates-table': {
        reactLazyComponent: () => FxRatesTableLazy,
    },
    'employee-list': {
        reactLazyComponent: () => EmployeeListLazy,
    },
    'branch-atm-search-single': {
        import: () => import(/* webpackChunkName: "branchAtmSearchSingle" */ 'modules/branchAtmSearch/branchAtmSearchSingle'),
    },
    'map-small': {
        reactLazyComponent: () => MapSmallLazy,
    },
    'fx-rates-chart': {
        reactLazyComponent: () => FxRatesChartLazy,
    },
    'section-with-restricted-access': {
        reactLazyComponent: () => SectionWithRestrictedAccessLazy,
    },
    'eam-map': {
        import: () => import(/* webpackChunkName: "eamLinkableMap" */ 'app/components/eamLinkableMap'),
        hasConfig: false,
    },
    search: {
        reactLazyComponent: () => SearchLazy,
    },
    'box-container': {
        reactLazyComponent: ({gemSettings}) => {
            if (gemSettings.theme === 'privatebanking') {
                return BoxContainerPBLazy;
            }

            return BoxContainerLazy;
        },
    },
    'box-container-author': {
        reactLazyComponent: () => BoxContainerAuthorLazy,
    },
    'box-container-config': {
        reactLazyComponent: () => BoxContainerConfigLazy,
    },
    'viewport-center': {
        import: () => import(/* webpackChunkName: "isInViewportCenter" */ 'app/modules/isInViewportCenter'),
        hasConfig: false,
    },
    'smart-banner': {
        import: ({config}) => {
            initSmartBanner(config as AndroidAppBannerConfig);
            return Promise.resolve();
        },
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'page-checkpoint': {
        import: () => import(/* webpackChunkName: "pageCheckpoint" */ 'app/modules/pageCheckpoint'),
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'page-trigger': {
        import: () => import(/* webpackChunkName: "pageTrigger" */ 'app/components/pageTrigger'),
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'page-trigger-redirect': {
        import: () => import(/* webpackChunkName: "pageTriggerRedirect" */ 'app/components/pageTrigger/redirect'),
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    alert: {
        import: () => import(/* webpackChunkName: "alert" */ 'app/components/alert'),
    },
    'carousel-ssr': {
        reactLazyComponent: ({config}) => {
            const carouselConfig = config as SuperheroCarouselConfig | TextWithImageCarouselConfig;
            if (carouselConfig.componentType === 'superhero-carousel') {
                return SuperheroCarouselLazy;
            }

            return TextWithImageCarouselLazy;
        },
    },
    'box-filter-container': {
        reactLazyComponent: () => BoxFilterContainerLazy,
    },
    'institute-selection': {
        reactLazyComponent: () => InstituteSelectionLazy,
    },
    chart: {
        reactLazyComponent({config}) {
            const chartConfig = config as ChartConfig;
            if (chartConfig.advanced?.useDynamicData) {
                return DynamicChartLazy;
            }

            return StaticPieChartLazy;
        },
    },
    'contact-options': {
        import: () => import(/* webpackChunkName: "contactOptions" */ 'app/components/contactOptions'),
        hasConfig: false,
    },
    'code-highlight': {
        import: () => import(/* webpackChunkName: "codeHighlight" */ 'app/components/codeHighlight'),
        hasConfig: false,
    },
    'country-selection': {
        reactLazyComponent: () => CountrySelectionLazy,
    },
    'table-archive': {
        reactLazyComponent: () => TableArchiveLazy,
    },
    'group-timelines': {
        reactLazyComponent: () => GroupTimelinesLazy,
    },
    'social-media-feed': {
        reactLazyComponent: () => SocialMediaFeedLazy,
    },
    poll: {
        reactLazyComponent: () => PollLazy,
    },
    superhero: {
        import: () => import(/* webpackChunkName: "superhero" */ 'app/components/superhero'),
    },
    'animated-headline': {
        import: () => import(/* webpackChunkName: "animatedHeadline" */ 'app/components/superhero/animatedHeadline'),
        hasConfig: false,
    },
    'form-upload': {
        import: ({element, gemSettings}) =>
            import(/* webpackChunkName: "formUpload" */ 'app/components/formUpload').then((module) => new module.FormUpload(element, gemSettings)),
    },
    'vertical-align': {
        import: () => import(/* webpackChunkName: "verticalAlign" */ 'modules/verticalAlignFactory'),
    },
    'lazy-back': {
        import: () => import(/* webpackChunkName: "lazyBack" */ 'app/modules/lazyBack'),
        hasConfig: false,
    },
    comments: {
        reactLazyComponent: () => CommentsLazy,
    },
    'api-powered-container-old': {
        import: () => import(/* webpackChunkName: "apiPoweredContainerOld" */ 'app/components/apiPoweredContainerOld'),
    },
    'api-powered-container': {
        reactLazyComponent: () => ApiPoweredContainerLazy,
    },
    'user-profile': {
        reactLazyComponent: () => UserProfileLazy,
    },
    'action-button': {
        import: ({element}) => import(/* webpackChunkName: "submit" */ 'app/components/actionButton').then((module) => new module.Submit(element)),
    },
    'tab-navigation': {
        reactLazyComponent: () => TabNavigationLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('tabNavigation'),
    },
    'compact-tab-navigation': {
        reactLazyComponent: () => CompactTabNavigationLazy,
    },
    'site-contact': {
        import: ({gemSettings}) => {
            if (gemSettings.theme === 'privatebanking') {
                return import(/* webpackChunkName: "siteContactPb" */ 'app/components/siteContact/pb');
            }

            return import(/* webpackChunkName: "siteContact" */ 'app/components/siteContact');
        },
        hasConfig: false,
    },
    'news-archive': {
        reactLazyComponent: () => NewsArchiveLazy,
    },
    'news-timeline': {
        reactLazyComponent: () => NewsTimelineLazy,
    },
    'news-headline': {
        reactLazyComponent: () => NewsHeadlineLazy,
    },
    'go-back': {
        reactLazyComponent: () => GoBackLazy,
        hasConfig: false,
    },
    'help-center-es': {
        reactLazyComponent: () => HelpCenterEsLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('helpCenterListEs'),
    },
    options: {
        import: () => import(/* webpackChunkName: "options" */ 'app/components/options'),
        hasConfig: false,
    },
    'key-numbers': {
        import: () => import(/* webpackChunkName: "keyNumbers" */ 'app/components/keyNumbers'),
        hasConfig: false,
    },
    'etb-offers-list': {
        reactLazyComponent: () => OffersListLazy,
    },
    'in-page-navigation': {
        reactLazyComponent: () => InPageNavigationInitLazy,
    },
    'css-legacy-loader-default-container': {
        import: () => import(/* webpackChunkName: "cssLegacyLoaderDefaultContainer" */ 'app/modules/cssLegacyLoader/defaultContainer'),
        hasConfig: false,
    },
    'file-list': {
        import: ({gemSettings}) => {
            switch (gemSettings.theme) {
                case 'wsd':
                    return import(/* webpackChunkName: "wsdFileList" */ 'app/components/fileList/wsd');
                case 'privatebanking':
                    return import(/* webpackChunkName: "pbFileList" */ 'app/components/fileList/pb');
                case 'flottenmanagement':
                    return import(/* webpackChunkName: "fmFileList" */ 'app/components/fileList/fm');
                default:
                    return import(/* webpackChunkName: "fileList" */ 'app/components/fileList');
            }
        },
        hasConfig: false,
    },
    'file-list-info': {
        reactLazyComponent: () => FileInfoLazy,
        hasConfig: false,
    },
    selection: {
        reactLazyComponent: () => ComboboxLazy,
    },
    'branch-search': {
        reactLazyComponent({config}) {
            const branchSearchConfig = config as BranchSearchConfig;
            if (branchSearchConfig.general.type === 'LIST') {
                return BranchSearchListLazy;
            }

            return BranchSearchMapAndListLazy;
        },
    },
    toggle: {
        reactLazyComponent: () => ToggleLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('toggle'),
    },
    'api-link': {
        reactLazyComponent: () => ApiLinkLazy,
    },
    'mobile-header': {
        reactLazyComponent: () => MobileHeaderLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('mobileHeader'),
    },
    sitemap: {
        import: () => import(/* webpackChunkName: "sitemap" */ 'app/components/sitemap'),
        hasConfig: false,
    },
    'group-map': {
        reactLazyComponent: () => GroupMapLazy,
    },
    'form-date': {
        import: () => import(/* webpackChunkName: "formDate" */ 'modules/formDate/formDateFactory'),
        hasConfig: false,
    },
    'form-numeric': {
        import: () => import(/* webpackChunkName: "formNumeric" */ 'modules/formNumeric/formNumericFactory'),
        hasConfig: false,
    },
    barcode: {
        reactLazyComponent: () => BarcodeLazy,
    },
    'interactive-map': {
        reactLazyComponent: () => ContactPageMapLazy,
        hasConfig: false,
        removePortalContent: false,
    },
    'regional-wall': {
        import: () => import(/* webpackChunkName: "regionalWall" */ 'app/components/regionalWall'),
        hasConfig: false,
        shouldSkipLazyLoad: () => 'LOAD_EAGER',
    },
    'news-config': {
        reactLazyComponent: () => NewsConfigLazy,
    },
    'header-button': {
        reactLazyComponent: () => HeaderButtonLazy,
    },
    'sticky-column': {
        reactLazyComponent: () => StickyColumnLazy,
        hasConfig: false,
    },
    glossary: {
        reactLazyComponent: () => GlossaryLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('glossary'),
    },
    'hero-search': {
        reactLazyComponent: () => HeroSearchLazy,
    },
    cnp: {
        import: () => import(/* webpackChunkName: "cnp" */ 'app/components/cnp'),
        hasConfig: false,
    },
    oib: {
        import: () => import(/* webpackChunkName: "oib" */ 'app/components/oib'),
        hasConfig: false,
    },
    'compact-offer-list': {
        reactLazyComponent: () => CompactOffersListLazy,
    },
    'mini-call-to-action': {
        import: () => import(/* webpackChunkName: "miniCallToAction" */ 'app/components/miniCallToAction'),
        hasConfig: false,
    },
    'service-box': {
        import: () => import(/* webpackChunkName: "serviceBox" */ 'app/components/serviceBox'),
    },
    'site-contact-css': {
        import: ({gemSettings}) => {
            if (gemSettings.theme === 'privatebanking') {
                return import(/* webpackChunkName: "siteContactCssPb" */ 'app/modules/cssLegacyLoader/siteContact/pb');
            }

            return import(/* webpackChunkName: "siteContactCss" */ 'app/modules/cssLegacyLoader/siteContact');
        },
        hasConfig: false,
    },
    header: {
        reactLazyComponent: () => HeaderLazy,
        hasConfig: false,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('header'),
    },
    'scroll-info-loader': {
        import: () => import(/* webpackChunkName: "scrollInfoLoader" */ 'app/modules/scrollInfoLoader'),
        hasConfig: false,
    },
    'widget-loader': {
        import: () => import(/* webpackChunkName: "widgetLoader" */ 'app/components/widgetLoader'),
    },
    'unrestricted-html': {
        reactLazyComponent: () => UnrestrictedHtmlLazy,
    },
    'section-with-effects': {
        reactLazyComponent: () => SectionWithEffectsLazy,
    },
    'cre-references-map': {
        reactLazyComponent: () => CreReferencesMapLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('creReferencesMap'),
    },
    'fund-scenarios': {
        reactLazyComponent: () => FundScenariosLazy,
    },
    'product-highlight': {
        reactLazyComponent: () => ProductHighlightLazy,
    },
    // header components START
    'text-with-image-header': {
        import: () => import(/* webpackChunkName: "textWithImageHeader" */ 'app/components/header/navigation/textWithImage/init'),
    },
    'navigation-link-block-header': {
        import: () => import(/* webpackChunkName: "navigationLinkBlockHeader" */ 'app/components/header/navigation/navigationLinkBlock/init'),
    },
    'service-box-header': {
        import: () => import(/* webpackChunkName: "serviceBoxHeader" */ 'app/components/header/navigation/serviceBox/init'),
    },
    'teaser-box-header': {
        import: () => import(/* webpackChunkName: "teaserBoxHeader" */ 'app/components/header/navigation/teaserBox/init'),
    },
    // header components END
    // footer components START
    'footer-navigation': {
        reactLazyComponent: () => FooterLazy,
    },
    'author-footer-navigation': {
        reactLazyComponent: () => FooterAuthorLazy,
        removePortalContent: false,
    },
    'author-service-links-footer': {
        import: () => import(/* webpackChunkName: "authorServiceLinksFooter" */ 'app/components/footer/components/serviceLinks/author'),
    },
    'author-breadcrumbs-footer': {
        import: () => import(/* webpackChunkName: "authorBreadcrumbsFooter" */ 'app/components/footer/components/breadcrumbs/author'),
    },
    'author-social-footer': {
        import: () => import(/* webpackChunkName: "authorSocialFooter" */ 'app/components/footer/components/social/author'),
    },
    'author-site-footer': {
        import: () => import(/* webpackChunkName: "authorSiteFooter" */ 'app/components/footer/components/siteFooter/author'),
    },
    'author-navigation-link-block-footer': {
        import: () =>
            import(/* webpackChunkName: "authorNavigationLinkBlockFooter" */ 'app/components/footer/components/navigation/navigationLinkBlock/author'),
    },
    'author-service-box-footer': {
        import: () => import(/* webpackChunkName: "authorServiceBoxFooter" */ 'app/components/footer/components/navigation/serviceBox/author'),
    },
    'author-image-links-footer': {
        import: () => import(/* webpackChunkName: "authorImageLinksFooter" */ 'app/components/footer/components/navigation/imageLinks/author'),
    },
    // footer components END,
    superform: {
        reactLazyComponent: () => SuperformLazy,
    },
    'author-text-input': {
        import: () => import(/* webpackChunkName: "superform_authorTextInput" */ 'app/components/superform/components/textInput/author'),
    },
    'author-text-area': {
        import: () => import(/* webpackChunkName: "superform_authorTextArea" */ 'app/components/superform/components/textArea/author'),
    },
    'author-select-input': {
        import: () => import(/* webpackChunkName: "superform_authorSelectInput" */ 'app/components/superform/components/selectInput/author'),
    },
    'author-alert': {
        import: () => import(/* webpackChunkName: "superform_authorAlert" */ 'app/components/superform/components/alert/author'),
    },
    'author-api-combobox': {
        import: () => import(/* webpackChunkName: "superform_authorApiCombobox" */ 'app/components/superform/components/apiCombobox/author'),
    },
    'author-numeric-input': {
        import: () => import(/* webpackChunkName: "superform_authorNumericInput" */ 'app/components/superform/components/numericInput/author'),
    },
    'author-date-input': {
        import: () => import(/* webpackChunkName: "superform_authorDateInput" */ 'app/components/superform/components/dateInput/author'),
    },
    'author-select-month-and-year-input': {
        import: () =>
            import(/* webpackChunkName: "superform_authorSelectMonthAndYearInput" */ 'app/components/superform/components/selectMonthAndYearInput/author'),
    },
    'author-rich-text': {
        import: () => import(/* webpackChunkName: "superform_authorRichText" */ 'app/components/superform/components/richText/author'),
    },
    'author-state-input': {
        import: () => import(/* webpackChunkName: "superform_authorStateInput" */ 'app/components/superform/components/stateInput/author'),
    },
    'author-visual-select-input': {
        import: () => import(/* webpackChunkName: "superform_authorVisualSelectInput" */ 'app/components/superform/components/visualSelectInput/author'),
    },
    'author-opt-in-input': {
        import: () => import(/* webpackChunkName: "superform_authorOptInInput" */ 'app/components/superform/components/optInInput/author'),
    },
    'author-recap': {
        import: () => import(/* webpackChunkName: "superform_authorRecap" */ 'app/components/superform/components/recap/author'),
    },
    'author-recap-cards': {
        import: () => import(/* webpackChunkName: "superform_authorRecapCards" */ 'app/components/superform/components/recapCards/author'),
    },
    'author-image': {
        import: () => import(/* webpackChunkName: "superform_authorImage" */ 'app/components/superform/components/image/author'),
    },
    'author-confirmation': {
        import: () => import(/* webpackChunkName: "superform_authorConfirmation" */ 'app/components/superform/components/confirmation/author'),
    },
    'author-upload': {
        import: () => import(/* webpackChunkName: "superform_authorUpload" */ 'app/components/superform/components/upload/author'),
    },
    'author-box': {
        import: () => import(/* webpackChunkName: "superform_authorBox" */ 'app/components/superform/components/boxContainer/author'),
    },
    'author-branch-input': {
        import: () => import(/* webpackChunkName: "superform_authorBranchInput" */ 'app/components/superform/components/branchInput/author'),
    },
    'author-phone-number-input': {
        import: () => import(/* webpackChunkName: "superform_authorPhoneNumberInput" */ 'app/components/superform/components/phoneNumberInput/author'),
    },
    'author-chart': {
        import: () => import(/* webpackChunkName: "superform_authorChart" */ 'app/components/superform/components/chart/author'),
    },
    'author-barcode': {
        import: () => import(/* webpackChunkName: "superform_authorBarcode" */ 'app/components/superform/components/barcode/author'),
    },
    'author-short-info': {
        import: () => import(/* webpackChunkName: "superform_authorShortInfo" */ 'app/components/superform/components/shortInfo/author'),
    },
    'author-recap-list': {
        import: () => import(/* webpackChunkName: "superform_authorRecapList" */ 'app/components/superform/components/recapList/author'),
    },
    'author-email-verification-input': {
        import: () => import(/* webpackChunkName: "superform_emailVerificationInput" */ 'app/components/superform/components/emailVerificationInput/author'),
    },
    'author-quiz-question': {
        import: () => import(/* webpackChunkName: "superform_quizQuestion" */ 'app/components/superform/components/quizQuestion/author'),
    },
    'be-ready-tab-selector': {
        import: () => import(/* webpackChunkName: "beReadyTabSelector" */ 'app/components/beReadyTabSelector'),
    },
    'be-ready-likes': {
        reactLazyComponent: () => BeReadyLikesLazy,
    },
    'audio-container': {
        reactLazyComponent: () => AudioContainerLazy,
        shouldSkipLazyLoad: getShouldSkipLazyLoadFn('audioContainer'),
    },
    'product-pricing-box-container': {
        reactLazyComponent: () => ProductPricingBoxContainerLazy,
    },
    'timebank-user-profile': {
        reactLazyComponent: () => TimebankLazy,
    },
    'superhero-ssr': {
        reactLazyComponent: () => SuperheroSSRLazy,
    },
    'api-boxes': {
        reactLazyComponent: () => ApiBoxesLazy,
    },
    'animated-bar-chart': {
        reactLazyComponent: () => AnimatedBarChartLazy,
    },
};
